import type { ColumnDef } from "@tanstack/react-table";
import { Badge } from "@/core/components/ui/badge";
import { Stack } from "@/core/components/ui/stack";
import type { ApVendor } from "@/accounts-payable/types";
import { cn } from "@/core/utils/utils";

// Inactive is the exception, so it's the only state that gets a badge (and a
// quieter name); active vendors carry no label at all.
export const vendorCol: ColumnDef<ApVendor> = {
  id: "name",
  header: "Vendor",
  accessorFn: (row) => row.name,
  meta: { size: "300px" },
  cell: ({ row }) => (
    <Stack direction="row" gap="sm" align="center">
      <span
        className={cn("font-medium", {
          "text-tertiary-text": !row.original.active,
        })}
      >
        {row.original.name}
      </span>
      {!row.original.active && (
        <Badge variant="gray" size="sm">
          Inactive
        </Badge>
      )}
    </Stack>
  ),
};
